import FullWidthLayout from "@/layouts/FullWidthLayout";
import KServiceTypesTable from "kinnect-front/KService/KServiceTypesTable";
import { FetchesData, Pageable } from "kinnect-mixins";
import { KTextField } from "kinnect-general";
import { ServiceType } from "kinnect-models";
import { VCard, VSheet } from "vuetify/lib";

export default {
	name: "ServiceTypesPage",

	metaInfo: { title: "Service Center - Statuses" },

	mixins: [
		FetchesData,
		Pageable
	],

	data: () => ( {
		serviceTypes: [],
		search: ""
	} ),

	computed: {
		numServiceTypes() {
			return this.serviceTypes.length;
		},

		toolbarActions() {
			if ( this.$can( "add_service_types" ) ) {
				return {
					icon: "add_circle",
					text: "Add Status",
					to: { name: "serviceTypeAdd" },
					tooltip: "Add a new status type"
				};
			}
		}
	},

	watch: {
		numServiceTypes( numServiceTypes ) {
			this.$store.dispatch( "breadcrumbs/setDetails", `${numServiceTypes} statuses` );
		}
	},

	methods: {
		async fetchServiceTypes() {
			this.serviceTypes = await ServiceType.get();
		},

		async fetch() {
			await this.fetchServiceTypes();
		}
	},

	render() {
		return <FullWidthLayout>
			<VCard>
				<VSheet class="pa-3" color="primary" tile>
					<KTextField
						clearable
						dark
						flat
						hideDetails
						label="Search"
						prependInnerIcon="search"
						soloInverted
						vModel={this.search}
					></KTextField>
				</VSheet>

				<KServiceTypesTable
					items={this.serviceTypes}
					loading={this.$wait.is( "get service types" )}
					search={this.search}
				></KServiceTypesTable>
			</VCard>
		</FullWidthLayout>;
	}
};
